import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "../../client/components/ui/dialog";
import { Button } from "../../client/components/ui/button";
import useTranslation from "../../client/hooks/useTranslation";

export type ImportDestination = "current" | "new-page" | "save-only";

export interface ImportLayoutDialogProps {
  open: boolean;
  onOpenChange: (b: boolean) => void;
  layoutName: string;
  mode: "library" | "new-page";
  canImportCurrent?: boolean;
  canCreatePage?: boolean;
  busy?: boolean;
  onConfirm: (destination: ImportDestination) => void;
}

export default function ImportLayoutDialog({
  open,
  onOpenChange,
  layoutName,
  mode,
  canImportCurrent = true,
  canCreatePage = true,
  busy = false,
  onConfirm,
}: ImportLayoutDialogProps) {
  const t = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>{t.dashboard.layouts.importConfirmTitle}</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          <span className="font-medium text-foreground">{layoutName}</span>
        </p>
        <div className="space-y-2 pt-1">
          {mode === "library" && canImportCurrent && (
            <Button
              variant="outline"
              className="w-full justify-start text-sm"
              disabled={busy}
              onClick={() => onConfirm("current")}
            >
              {t.dashboard.layouts.importConfirmOnThisPage}
            </Button>
          )}
          {canCreatePage && (
            <Button
              variant="outline"
              className="w-full justify-start text-sm"
              disabled={busy}
              onClick={() => onConfirm("new-page")}
            >
              {mode === "new-page"
                ? t.dashboard.layouts.newPageWithLayout
                : t.dashboard.layouts.importConfirmNewPage}
            </Button>
          )}
          {mode === "library" && (
            <Button
              variant="outline"
              className="w-full justify-start text-sm"
              disabled={busy}
              onClick={() => onConfirm("save-only")}
            >
              {t.dashboard.layouts.importConfirmSaveOnly}
            </Button>
          )}
          {mode === "new-page" && (
            <Button
              variant="ghost"
              className="w-full justify-start text-sm text-muted-foreground"
              disabled={busy}
              onClick={() => onConfirm("save-only")}
            >
              {t.dashboard.layouts.newPageBlank}
            </Button>
          )}
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)} disabled={busy}>
            {t.common.cancel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
